import { render, staticRenderFns } from "./versions.vue?vue&type=template&id=4ee4f0c1&scoped=true"
import script from "./versions.vue?vue&type=script&lang=js"
export * from "./versions.vue?vue&type=script&lang=js"
import style0 from "./versions.vue?vue&type=style&index=0&id=4ee4f0c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee4f0c1",
  null
  
)

export default component.exports